// 2026-06-25: Phase 2 — WorkOrder service (frontend axios helpers)
import axios from 'axios';

const BASE = `${window._env_.SERVER_URL2}api/workorder`;
function ax() { return axios.create({ baseURL: BASE, timeout: 15000 }); }

export async function listWorkCenters(customer_id, shop_type) {
  const r = await ax().get('/work-centers', { params: { customer_id, shop_type } });
  return r.data;
}

export async function listWorkOrders(customer_id, filters = {}) {
  const r = await ax().get('/list', { params: { customer_id, ...filters } });
  return r.data;
}

export async function getWorkOrderDetail(customer_id, wo_id) {
  const r = await ax().get(`/detail/${wo_id}`, { params: { customer_id } });
  return r.data;
}

export async function updateWorkOrder(customer_id, wo_id, body) {
  const r = await ax().post(`/update/${wo_id}`, { customer_id, ...body });
  return r.data;
}

export async function deleteWorkOrder(customer_id, wo_id) {
  const r = await ax().post(`/delete/${wo_id}`, { customer_id });
  return r.data;
}

export async function createWorkOrder(body) {
  const r = await ax().post('/create', body);
  return r.data;
}

export async function releaseWorkOrder(customer_id, wo_id) {
  const r = await ax().post(`/release/${wo_id}`, { customer_id });
  return r.data;
}

export async function getOperatorQueue(customer_id, filters = {}) {
  const r = await ax().get('/operator-queue', { params: { customer_id, ...filters } });
  return r.data;
}

export async function updateOperationSetupByPosition(customer_id, op_seq, setup_enabled) {
  const r = await ax().post('/operations/setup-by-position', { customer_id, op_seq, setup_enabled });
  return r.data;
}

export async function startOperation(op_id, body) {
  const r = await ax().post(`/operation/${op_id}/start`, body);
  return r.data;
}

export async function claimOperation(op_id, body) {
  const r = await ax().post(`/operation/${op_id}/claim`, body);
  return r.data;
}

export async function seedDemo(customer_id) {
  const r = await ax().post('/seed-demo', { customer_id });
  return r.data;
}

export async function pauseOperation(op_id, body) {
  const r = await ax().post(`/operation/${op_id}/pause`, body);
  return r.data;
}

export async function resumeOperation(op_id, body) {
  const r = await ax().post(`/operation/${op_id}/resume`, body);
  return r.data;
}

// === Phase 8b 2026-06-25: Scheduling ===
export async function getScheduleGrid(customer_id, start, end, include_holidays = false) {
  const r = await ax().get('/schedule/grid', { params: { customer_id, start, end, include_holidays } });
  return r.data;
}

export async function getScheduleCapacity(customer_id, start, end, include_holidays = false) {
  const r = await ax().get('/schedule/capacity', { params: { customer_id, start, end, include_holidays } });
  return r.data;
}

export async function autoSchedule(customer_id, start_from) {
  const r = await ax().post('/schedule/auto', { customer_id, start_from });
  return r.data;
}

export async function unscheduleOperation(op_id, customer_id) {
  const r = await ax().post(`/operation/${op_id}/unschedule`, { customer_id });
  return r.data;
}

export async function scheduleOperation(op_id, body) {
  const r = await ax().post(`/operation/${op_id}/schedule`, body);
  return r.data;
}

// === Phase 9 2026-06-25: NC + Rework Order ===
export async function createNc(body) {
  const r = await ax().post('/nc-log', body);
  return r.data;
}

export async function listNcs(customer_id, filters = {}) {
  const r = await ax().get('/nc-log', { params: { customer_id, ...filters } });
  return r.data;
}

export async function disposeNc(nc_id, body) {
  const r = await ax().post(`/nc-log/${nc_id}/dispose`, body);
  return r.data;
}

export async function listReworkOrders(customer_id, filters = {}) {
  const r = await ax().get('/rework-orders', { params: { customer_id, ...filters } });
  return r.data;
}

export async function claimReworkOrder(rework_id, body) {
  const r = await ax().post(`/rework-order/${rework_id}/claim`, body);
  return r.data;
}

export async function getLossesReport(customer_id, start, end) {
  const r = await ax().get('/report/losses', { params: { customer_id, start, end } });
  return r.data;
}

// === Phase 10 2026-06-25: BOM + ECR + ECN ===
export async function listBoms(customer_id, part_number) {
  const r = await ax().get('/boms', { params: { customer_id, part_number } });
  return r.data;
}
export async function getBomDetail(customer_id, bom_id) {
  const r = await ax().get(`/bom/${bom_id}`, { params: { customer_id } });
  return r.data;
}
export async function createBom(body) {
  const r = await ax().post('/bom', body);
  return r.data;
}
export async function listEcrs(customer_id, status) {
  const r = await ax().get('/ecrs', { params: { customer_id, status } });
  return r.data;
}
export async function createEcr(body) {
  const r = await ax().post('/ecr', body);
  return r.data;
}
export async function approveEcr(ecr_id, body) {
  const r = await ax().post(`/ecr/${ecr_id}/approve`, body);
  return r.data;
}
export async function rejectEcr(ecr_id, body) {
  const r = await ax().post(`/ecr/${ecr_id}/reject`, body);
  return r.data;
}
export async function listEcns(customer_id, status) {
  const r = await ax().get('/ecns', { params: { customer_id, status } });
  return r.data;
}
export async function getEcnDetail(customer_id, ecn_id) {
  const r = await ax().get(`/ecn/${ecn_id}`, { params: { customer_id } });
  return r.data;
}
export async function createEcn(body) {
  const r = await ax().post('/ecn', body);
  return r.data;
}
export async function issueEcn(ecn_id, body) {
  const r = await ax().post(`/ecn/${ecn_id}/issue`, body);
  return r.data;
}
export async function implementEcn(ecn_id, body) {
  const r = await ax().post(`/ecn/${ecn_id}/implement`, body);
  return r.data;
}
